import { render, staticRenderFns } from "./ZoneAttributes.vue?vue&type=template&id=03d0ed4a"
import script from "./ZoneAttributes.vue?vue&type=script&lang=ts"
export * from "./ZoneAttributes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports